import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import StripeLoginButton from './StripeLoginButton';
import StripeOnboardButton from './StripeOnboardButton';

const listItemSx = {
  marginBottom: '12px',
  padding: '16px',
  borderBottom: '1px solid #e0e0e0',
};

const gridContainerSx = {
  alignItems: 'center',
};

const gridItemSx = {
  textAlign: 'left',
};

const outerBoxSx = {
  padding: '30px',
  borderRadius: '8px',
};

const MyAccount = ({ clinicAdminData }) => {
  const { clinic } = clinicAdminData;

  const renderListItem = (label, value) => (
    <ListItem sx={listItemSx}>
      <Grid container sx={gridContainerSx}>
        <Grid size={6} sx={gridItemSx}>
          <Typography variant="body1" color="textSecondary">
            {label}
          </Typography>
        </Grid>
        <Grid size={6} sx={gridItemSx}>
          <Typography variant="body1" color="textPrimary">
            {value}
          </Typography>
        </Grid>
      </Grid>
    </ListItem>
  );

  return (
    <Box sx={outerBoxSx}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        <FormattedMessage defaultMessage="My Account" />
      </Typography>
      <List disablePadding>
        {renderListItem(
          <FormattedMessage defaultMessage="First Name" />,
          clinicAdminData.first_name,
        )}
        {renderListItem(
          <FormattedMessage defaultMessage="Last Name" />,
          clinicAdminData.last_name,
        )}
        {renderListItem(
          <FormattedMessage defaultMessage="Email" />,
          clinicAdminData.email,
        )}
        {renderListItem(
          <FormattedMessage defaultMessage="Clinic Token" />,
          clinic?.clinic_token,
        )}
        <ListItem sx={listItemSx}>
          <Grid container sx={gridContainerSx}>
            <Grid size={6} sx={gridItemSx}>
              <Typography variant="body1" color="textSecondary">
                <FormattedMessage defaultMessage="Stripe Onboarding" />
              </Typography>
            </Grid>
            <Grid size={6} sx={gridItemSx}>
              {clinic?.onboarded ? (
                <StripeLoginButton />
              ) : (
                <StripeOnboardButton />
              )}
            </Grid>
          </Grid>
        </ListItem>
      </List>
    </Box>
  );
};

MyAccount.propTypes = {
  clinicAdminData: PropTypes.object.isRequired,
};

export default injectIntl(MyAccount);
